import React from "react";
import { useTranslation } from "react-i18next";

import { cn } from "../lib/utils";
import { SUPPORTED_LANGUAGES, SupportedLanguage, currentLanguage } from "../i18n";

interface Props {
  /** "light" para o cabeçalho claro, "dark" para o rodapé escuro */
  tone?: "light" | "dark";
  className?: string;
}

/** Seletor PT / EN / ES. A escolha fica salva no navegador. */
export default function LanguageSwitcher({ tone = "light", className }: Props) {
  const { t, i18n } = useTranslation();
  const active = currentLanguage();

  const change = (lang: SupportedLanguage) => {
    if (lang !== active) i18n.changeLanguage(lang);
  };

  return (
    <div
      role="group"
      aria-label={t("lang.label")}
      className={cn(
        "inline-flex items-center rounded-full border p-0.5 text-xs font-semibold uppercase",
        tone === "light" ? "border-slate-200 bg-white" : "border-slate-700 bg-slate-800",
        className
      )}
    >
      {SUPPORTED_LANGUAGES.map((lang) => {
        const isActive = lang === active;
        return (
          <button
            key={lang}
            type="button"
            lang={lang}
            aria-pressed={isActive}
            aria-label={t(`lang.${lang}`)}
            title={t(`lang.${lang}`)}
            onClick={() => change(lang)}
            className={cn(
              "rounded-full px-2.5 py-1 transition",
              isActive
                ? "bg-primary text-primary-foreground shadow-sm"
                : tone === "light"
                ? "text-slate-500 hover:text-primary"
                : "text-slate-400 hover:text-white"
            )}
          >
            {lang}
          </button>
        );
      })}
    </div>
  );
}
